// Helper
import { date } from 'helpers/format'

// Model
import Model from 'models/Model'

export const RESOLVED = 'resolved'
export const CLOSED = 'closed'

export default class TicketModel extends Model {
  get id() {
    return this.model.id
  }

  get ticketNo() {
    return this.model.ticketNumber
  }

  get createdAt() {
    if (this.model.createDate) {
      return date(this.model.createDate)
    }
    return date(this.model.dateSent)
  }

  get raisedAt() {
    if (this.model.createDate) {
      return date(this.model.createDate, 'MMM-dd-yyyy')
    }
    return date(this.model.dateSent, 'MMM-dd-yyyy')
  }

  get closedAt() {
    return date(this.model.closedDate, 'MMM-dd-yyyy')
  }

  get category() {
    return this.model.category
  }

  get type() {
    return this.model.type || 'N/A'
  }

  get content() {
    return this.model.concern
  }

  get status() {
    const status = this.model.ticketStatus

    if (typeof status === 'string') {
      return status.toLowerCase()
    }

    return status
  }

  get files() {
    if (Array.isArray(this.model.attachmentFileNames)) {
      return this.model.attachmentFileNames.map((name) => {
        return {
          name,
          status: 'done',
        }
      })
    }
    return []
  }

  get isResolved() {
    return this.status === RESOLVED
  }

  get isClosed() {
    return this.status === CLOSED
  }

  get lessorName() {
    return this.model.lessorName
  }

  get vendorCode() {
    return this.model.vendorCode
  }

  get companyCode() {
    return this.model.companyCode
  }

  get contractNo() {
    return this.model.contractNumber
  }
}
